import script from "./ResultsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsTable.vue?vue&type=script&setup=true&lang=js"

import "./ResultsTable.vue?vue&type=style&index=0&id=14ffb915&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ffb915"]])

export default __exports__